import { c as _c } from "react/compiler-runtime";
import { MagnusLogo } from "@magnus/react/branding";
import Link from "next/link";

/**
 * A rule across the foot of the chrome-less pages with the mark set into it,
 * and the way home from a page that has no navigation of its own.
 *
 * Monochrome and dim on purpose: the accent on these pages belongs to the
 * status code, and a footer that competes with it is a footer in the wrong
 * place.
 */
export function ErrorPageFooter() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden="true" className="h-px flex-1 bg-border" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <footer className="mx-auto flex w-full max-w-3xl items-center gap-4 px-6 pb-8">{t0}<Link aria-label="Magnus home" className="rounded-sm text-muted-foreground/60 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" href="/"><MagnusLogo className="size-7" /></Link><span aria-hidden="true" className="h-px flex-1 bg-border" /></footer>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}